export const signatureRequirements = [
    {value: "none", label: "None"},
    {value: "general", label: "General"},
    {value: "adult", label: "Adult"},
    {value: "recipient", label: "Recipient"},
]

export const emailNotifs = [
    {value: "delivery", label: "Delivery"},
    {value: "pickup", label: "Pickup"},
    {value: "exception", label: "Exception"},
]

export const paymentMethods = [
    {value: "cc", label: "Credit Card"},
    {value: "billShipper", label: "Bill Shipper"},
]

export const mexicoService = {
    "service_id": "M",
    "addl_description_1": null,
    "addl_description_2": null,
    "service_class": "International",
    "selection_order": null,
    "name": "Mexico",
    "allowed": true,
    "label": "LSO Mexico",
    "value": "Mexico",
}